import React from "react";
import { PROMO_ACTIVE } from "../features/promo/promoConfig";

// Payment after the reservation fee — the promo lowers the deposit
// from 20 % to 10 % of the price.
const depositPercent = PROMO_ACTIVE ? 10 : 20;
const restPercent = 100 - depositPercent;

export const contentTexts = {
  menu: {
    locality: "Lokalita",
    about: "O projekte",
    contact: "Kontakt",
    offer: "Ponuka bytov",
    finance: "Financovanie",
    gallery: "Galéria",
    partners: "Partneri",
  },
  cta: {
    contactUs: "Neváhajte nás kontaktovať",
    showFlats: "Zobraziť ponuku bytov",
    moreAbout: "Viac o projekte",
    knowMore: "Dozvedieť sa viac",
    locality: "Preskúmať lokalitu",
    benefits: "Zobraziť hlavné benefity",
  },
  other: {
    legal: "Všetky práva vyhradené",
    docs: {
      privacy: "Ochrana osobných údajov",
      gdpr: "GDPR",
      cookies: "Cookies",
      cookieSettings: "Nastavenia cookies",
    },
    disclaimer:
      "Všetky vizualizácie projektu Bell\xa0residence uvedené na tomto webe majú výlučne informatívny charakter a slúžia na marketingové účely.",
    description:
      "Rodinné bývanie, komfort mesta a krásne výhľady na štíty Vysokých Tatier, bez rušenia pokoja a kľudu polyfunkciou. To všetko vám prináša nový projekt Bell\xa0Residence.",
    showMore: "Zobraziť viac",
    created: "Vytvoril",
    contactType: {
      sales: "Predaj",
      finance: "Financovanie",
    },
  },
  promo: {
    badge: {
      eyebrow: "Akcia pokračuje",
      lead: "Znížená záloha",
      amount: "10\xa0%",
      note: "zvyšok až po kolaudácii",
    },
    popup: {
      eyebrow: "Akcia pokračuje",
      titleLead: "Znížená záloha len",
      titleAmount: "10\xa0%",
      text: "Na rezerváciu bytu vám aktuálne stačí uhradiť len 10\xa0% z ceny. Zvyšok doplatíte až po kolaudácii, pred prevzatím bytu.",
      cta: "Vybrať si byt",
      smallPrint: "Podrobnosti vám radi vysvetlíme osobne alebo telefonicky.",
      close: "Zavrieť",
    },
  },
  homePage: {
    heading: "81 nových bytov {breakLine}v tichej časti Popradu",
    description:
      "Rodinné bývanie, komfort mesta a výhľad na Vysoké Tatry. Moderná a ekologická novostavba, v ktorej nebudú žiadne obchody ani prevádzky, čo zaručí maximálnu mieru súkromia.",
    disposition: {
      title: "Dispozície bytov",
    },
    uniqueProject: {
      title: "Unikátny projekt",
      description:
        "Bell\xa0Residence je moderná stavba navrhnutá s dôrazom na kvalitu, ekológiu a komfort budúcich obyvateľov.",
    },
  },
  flatsPage: {
    heading: "Vyberte si bývanie v Poprade",
    subHeading:
      "V ponuke sú 1,5-izbové až 4-izbové byty.{breakLine}Byt si vyberiete v interaktívnom modeli alebo v {link}.",
    subHeadingMobile:
      "V ponuke sú 1,5-izbové až 4-izbové byty. Byt si vyberiete v prehľadnej tabuľke bytov.",
    hiddenPicker:
      "Pre výber bytu pomocou interaktívneho modelu projektu prosím použite zariadenie so širšou obrazovkou alebo navštívte náš web na počítači.",
    subHeadingLink: "prehľadnej tabuľke bytov",
    twoRoomHighlight: {
      title: "Nadštandardné 2-izbové byty v Poprade",
      text: "Najviac bytov v ponuke tvoria 2-izbové byty. Majú 52 až 59 m² a loggiu. Sú navrhnuté pre pohodlné bývanie aj pre výhodnú investíciu. Voľné 2-izbové byty nájdete v tabuľke vyššie. Radi vám pošleme pôdorysy a cenovú ponuku.",
    },
    table: {
      id: "Označenie",
      title: "Výber bytu",
      tower: "Budova",
      level: "Poschodie",
      disposition: "Dispozícia",
      floorSize: "Úžitková plocha",
      secondaryPlan: "Vedľajšia plocha",
      price: "Cena",
      state: "Stav",
      emptyState: {
        title: "Žiaľ, nenašli sa žiadne dostupné byty.",
        description: "Skúste upraviť, alebo zmazať použté filtre.",
      },
    },
    filter: {
      showFilters: "Zobraziť filtre",
      hideFilters: "Skryť filtre",
      disposition: "Vyberte si počet izieb",
      tower: "Vyberte si budovu",
      price: "Cena",
      floor_plan: "Úžitková plocha",
      onlyFree: "Zobraziť iba voľné byty",
    },
    stepper: {
      step_1: "Zvoľte budovu",
      step_2: "Zvoľte poschodie a vyberte si byt",
    },
  },
  detail: {
    preview_info:
      "Pôdorys je spracovaný na marketingové účely. Umiestnenie zariaďovacích predmetov má len informatívny charakter.",
    back: "Späť na ponuku",
    detailLabel: "Detail bytu:",
    priceFlat: "Základná cena bytu:",
    priceLegal:
      "(Ceny sú uvedené vrátane 23% DPH. Ceny sú platné do 31.3.2026)",
    priceCellar: "Cena kobky:",
    priceParking: "Cena parkovania:",
    priceParkingIncluded: "zahrnutá v cene bytu",
    priceOnDemand: "Cena dostupná na vyžiadanie - {link}",
    priceOnDemandLink: "kontaktujte nás",
    priceOnDemandShort: "Na vyžiadanie",
    parkingTypes: {
      G2: "K bytu prináležia dve podzemné parkovacie miesta.",
      G: "K bytu prináleží podzemné parkovacie miesto.",
      V: "K bytu prináleží vonkajšie parkovacie miesto.",
      VK: "K bytu prináleží vonkajšie kryté parkovacie miesto.",
    },
    flatSize: "Úžitková plocha:",
    cellarSize: "Plocha kobky:",
    terraceSize: "Vedľajšia plocha:",
    disposition: "Dispozícia",
    roomTypes: {
      wardrobe: "Šatník",
      office: "Pracovňa",
      bathroom: "Kúpeľňa",
      room: "Izba",
      hallway: "Chodba",
      toilet: "Toaleta",
      terrace: "Terasa",
      cellar: "Kobka",
      vestibule: "Predsieň",
      balcony: "Loggia",
      living_room_kitchen: "Obývacia miestnosť s kuchyňou",
      laundry: "Práčovňa",
    },
    interested: "Mám záujem",
    download_blueprint: "Stiahnúť pôdorys",
    flat_label: "Byt",
    floor_label: "poschodie",
    room_label: "izba",
    rooms_label: "izby",
    tower_label: "budova",
    parking_label: "parkovanie",
    form_title: "V prípade záujmu nás{breakLine}neváhajte kontaktovať",
    subjectSuffix: "Detail bytu",
    facilities: {
      title: "*{breakLine}Vybavenie",
      paragraph_1:
        "Byt je v stave holobytu s pripravenými rozvodmi vody, kanalizácie, podlahového vykurovania, rekuperácie, elektroinštalácií a slaboprúdových systémov.",
      paragraph_2:
        "V byte sa nachádza predpríprava na klimatizáciu. Podlahy sú ukončené betónovým poterom a steny so stropmi pokryté omietkami.",
    },
    interest: "Dobrý deň, mám záujem o viac informácií ohľadom bytu...",
  },
  contactForm: {
    name: "Meno a priezvisko",
    email: "E-mail",
    phone: "Telefónne číslo",
    message: "Vaša správa",
    consent: "Súhlasím so spracovaním {link}",
    link: "osobných údajov",
    submit: "Odoslať",
    validation: {
      phone: "Zadajte platné telefónne číslo (v tvare +421 123 456 789)",
      name: "Zadajte vaše meno a priezvisko",
      from: "Zadajte platnú e-mailovú adresu",
      message: "Zadajte vašu správu (min 1 znak)",
    },
    subjectMessage: "Nová správa z webu bellresidence.sk",
    successMessage:
      "Správa bola úspešne odoslaná. Ďakujeme, čoskoro sa vám ozveme.",
    errorMessage:
      "Nastala chyba pri odosielaní správy, skúste to prosím neskôr",
  },
  about: {
    title: "Novostavba Bell Residence",
    description:
      "Bell\xa0residence spája moderné technológie, ekologické princípy a komfortné bývanie, ktoré reaguje na aktuálne požiadavky udržateľnosti a kvality života. Pri navrhovaní projektu sme dali prednosť vášmu pokoju, súkromiu a bezpečnosti pred polyfunkciou. Žiadne rušivé elementy v podobe zásobovania, dlhých otváracích hodín prevádzok a množstvom cudzích ľudí. V tesnej blízkosti sa pre vás nachádza kompletná občianska vybavenosť.",
    counts: {
      title: "Bell {breakLine} v číslach...",
      button: "Pozrieť ponuku bytov",
      flatsCounts: {
        title: "Dispozične sú byty rozdelené do:",
        oneRoom: "- {number} jednoizbových",
        twoRoom: "- {number} dvojizbových",
        threeRoom: "- {number} trojizbových a",
        fourRoom: "- {number} štvorizbových jednotiek.",
      },
      flats: {
        title: "{count}bytov",
      },
      towers: {
        title: "v {count}vežiach",
      },
      floors: {
        title: "na {count}poschodiach",
        helpText: "+ (1 podzemné)",
      },
      parkingLots: {
        title: "s {count}parkovacími{breakLine}miestami",
      },
    },
    construction: {
      title: "Konštrukcia a dispozičné riešenie",
      paragraphs: {
        1: "Bell\xa0Residence je moderná stavba navrhnutá s dôrazom na kvalitu, ekológiu a komfort budúcich obyvateľov. Projekt spĺňa prísne stavebné a environmentálne normy, pričom sa využívajú pokročilé stavebné technológie a vysoko kvalitné materiály. Väčšie byty sa nachádzajú v 1.NP s predzáhradkou a na ustúpenom podlaží vo väzbe na zelené strechy, kde vám v oboch prípadoch vytvárame kvalitu bývania podobnú rodinnému domu s výhodami bývania v bytovom komplexe.",
        2: "Byty v ustúpenom podlaží (7.NP) poskytujú svojou polohou a orientáciou nadštandarný priestor s výhľadom vďaka celoobvodovým oknám a terasám na všetky svetové strany. Byty aj terasy sú priestranné, poskytujú dostatočný komfort pre individuálny relax, prípadne komunitné aktivity.",
        3: "Byty na podlažiach 1NP až 6NP sú rovnako komfortné a každý z nich má priestrannú loggiu. Z hľadiska dispozičného riešenia sú v bytoch obsiahnuté všetky potrebné priestory pre pohodlné a príjemné bývanie: predsieň, obývacia miestnosť s kuchyňou a s jedálňou, izby, kúpeľňa, samostatné WC (s výnimkou jednoizbových bytov, so samostatnou kuchynsko-obývacou časťou vo veži B), šatník, kobka, komora, loggia a pod.",
        4: "Média sú do bytov distribuované štandardným riešením cez inštalačné jadrá a šachty. Navrhované priestory sú dostatočne presvetlené, odvetrané a spĺňajú všetky požiadavky v zmysle príslušných STN. Všetky priestory objektov sú bezbariérovo prístupné aj z podzemných garáži, aj z parteru výťahmi a rampami v súlade s STN 73 4301 Bytové budovy a v súlade s vyhláškou č. 532/2002 Z.z. o všeobecných technických požiadavkách na stavby užívané osobami s obmedzenou schopnosťou pohybu a orientácie.",
      },
    },
    walls: {
      title: "Steny a fasáda",
      paragraphs: {
        1: "Nadzemná časť stavby je celoplošne zateplená systémom STO v zmysle požiadaviek na energetické riešenie. Fasádu domu sme navrhli v kombinácii kvalitných a ušľachtilých materiálov, t.j. kvalitnej omietky, obkladu a oplechovania. (Nadzemná časť fasády 1.PP a celá fasáda parkovacieho prístrešku na 1.NP bude celoplošne pokrytá predsadenou zelenou stenou (popínavá zeleň), umiestnená na oceľovej pozinkovanej konštrukcii z perforovaného plechu resp. ťahokovu).",
        2: "Jednotlivé skladby obvodových, nosných, strešných, presklených, konštrukcií budú spĺňať požiadavky súčasných noriem a trendov z hľadiska energetickej náročnosti budov s cieľom vytvoriť kvalitné riešenie do budúcnosti, ako aj požiadaviek zvukovej nepriezvučnosti pre zachovanie pohody bývania v zmysle platných EN STN.",
        3: "Nosné steny sú vyhotovené z monolitického železobetónu a doplnené o tehlové výplňové murivo. Povrchová úprava stien vo všetkých bytoch je realizovaná vápenno-cementovými omietkami, ktoré sú zakončené bielou náterovou vrstvou pre čistý a moderný vzhľad. Obvodové steny sú zateplené certifikovaným systémom STO, ktorý zabezpečuje výnimočné tepelnoizolačné vlastnosti a dlhodobú ochranu pred poveternostnými vplyvmi.",
      },
    },
    greenRoof: {
      title: "Zelená strecha",
      paragraphs: {
        1: "Budova je vybavená zelenou strechou, ktorá plní dôležitú ekologickú funkciu. Zelená strecha pomáha regulovať teplotu v budove, znižuje efekt mestského tepelného ostrova a prispieva k zadržiavaniu dažďovej vody.",
        2: "Okrem toho poskytuje estetický prvok a podporuje biodiverzitu. Prístrešky v okolí budovy sú navrhnuté s rovnakým dôrazom na funkčnosť a ekologický prístup.",
      },
    },
    boxes: {
      base: {
        title: "Základy a pivnice",
        description:
          "Základová doska je zhotovená zo železobetónu, čo poskytuje vysokú statickú stabilitu celej stavby. Podzemné podlažie je opatrené hydroizolačnou vrstvou, ktorá zabezpečuje ochranu proti prenikaniu vlhkosti. Priestory sú vybavené systémom núteného aj prirodzeného vetrania, čím sa predchádza kondenzácii a vzniku plesní.",
      },
      windows: {
        title: "Okná a zábradlia",
        description:
          "Všetky byty a spoločné priestory sú vybavené hliníkovými trojkomorovými oknami, ktoré poskytujú vynikajúcu tepelnú a zvukovú izoláciu. Spoločné priestory sú zabezpečené kvalitným nerezovým zábradlím a keramickou dlažbou, ktorá je odolná voči opotrebeniu.",
      },
      floors: {
        title: "Podlahy a interiéry",
        description:
          "V spoločných priestoroch sú položené keramické dlažby, ktoré sú trvácne a ľahko udržiavateľné. V bytových jednotkách sú steny pripravené s bielym náterom a podlahy pripravené na individuálne úpravy podľa požiadaviek vlastníkov.",
      },
      heating: {
        title: "Vykurovanie a ohrev TUV",
        description:
          "Vykurovanie budovy je napojené na centrálny vykurovací systém spoločnosti PES, ktorý zabezpečuje spoľahlivú dodávku tepla. Na streche budovy sú nainštalované fotovoltické panely, ktoré slúžia na výrobu elektrickej energie pre ohrev teplej úžitkovej vody (TUV), čím prispievajú k zníženiu prevádzkových nákladov a ekologickému fungovaniu budovy.",
      },
      canal: {
        title: "Kanalizácia a ekologické prvky",
        description:
          "Budova je vybavená dvojvetvovým kanalizačným systémom, ktorý efektívne separuje splaškovú a dažďovú vodu. Použité materiály a riešenia zohľadňujú princípy ekologickej výstavby, čím projekt dosahuje energetickú triedu A.",
      },
      elevator: {
        title: "Výťahy a technologické vybavenie",
        description:
          "Každá veža je vybavená moderným a spoľahlivým výťahom Schindler S3000. Tento výťah zabezpečuje plynulú prevádzku, nosnosť 630 kg (8 osôb) a dopravnú rýchlosť 1,0 m/s.",
      },
    },
    construction_works: {
      title: "Priebeh stavby",
      socials:
        "Pre aktuálny priebeh stavby sledujte naše sociálne siete, kde pravidelne zdieľame novinky a zábery z výstavby.",
      company:
        "Realizáciu stavby zabezpečuje skúsený generálny zhotoviteľ LK-PARTNER, ktorý garantuje vysoký štandard kvality a profesionálny prístup. Viac informácií nájdete na {link}",
    },
  },
  gallery: {
    title: "Galéria",
    description:
      "Prehliadnite si fotky z nášho projektu a zistite, ako bude vyzerať váš nový domov.",
  },
  locality: {
    main: {
      title: "Poprad-Juh",
      description:
        "Bell\xa0Residence sa nachádza v mestskej časti Poprad-Juh, ktorá spája mestský život s blízkosťou prírody.{breakLine}Preskúmajte lokalitu a objavte miesto, ktoré si zamilujete!",
    },
    peatland:
      "Vedľa rezidencie sa nachádza rašelinisko, vzácne prírodné územie so špeciálnou ochranou, ktoré prispieva k zachovaniu pokojného a prírodného prostredia. Predpokladá sa, že jeho ochranný status obmedzí ďalšiu výstavbu v tejto oblasti.",
    benefits: {
      title: "Hlavné benefity lokality",
      description:
        "Mesto Poprad poskytuje dokonalé prepojenie prírody a urbanizmu.",
      items: {
        tatras: {
          title: "Výhľad na Vysoké Tatry",
          description:
            "Nechajte sa očariť jedným z najkrajších výhľadov na národnú pýchu Slovenska – majestátne Vysoké Tatry.",
        },
        hike: {
          title: "Športové aktivity na dosah",
          description:
            "Poprad je vstupnou bránou k nekonečným športovým možnostiam – od relaxu v Aquacity, cez zimné športy, až po turistiku v tatranských dolinách. Miesto ponúka aj priame napojenie na cyklochodník Svit-Poprad.",
        },
        transport: {
          title: "Výborná dostupnosť verejnej dopravy",
          description:
            "Mesto ponúka výnimočné spojenie – hlavná železničná stanica, autobusové linky aj letisko sú vždy blízko.",
        },
        hospital: {
          title: "Zdravotná starostlivosť vždy poruke",
          description:
            "Moderné nemocnice a polikliniky v Poprade zaručujú rýchly prístup k zdravotnej starostlivosti pre vás a vašu rodinu.",
        },
      },
    },
    otherLocations: {
      title: "Ďalšie dôležité lokality v okolí",
      titles: {
        walkableLocations: "V pešej dostupnosti",
        driveableLocations: "V dojazdovej vzdialenosti",
        recreation: "Rekreačné možnosti",
      },
      items: {
        busStop: "zástavka MHD",
        pharmacy: "lekáreň",
        doctor: "detský a všeobecný lekár",
        school: "základná a materská škola",
        grocery: "potraviny",
        post: "pošta",
        vet: "veterina",
        hospital: "Popradská nemocnica s poliklinikou",
        groceries: "Kaufland / Lidl",
        publicTransport: "vlaková a autobusová stanica",
        airport: "Medzinárodné letisko Poprad Tatry",
        highway: "napojenie na diaľnicu D1 Poprad západ",
        golf: "golfové ihrisko Black Stork",
        smokovec: "Vysoké Tatry Starý Smokovec",
        lomnica: "Vysoké Tatry Tatranská Lomnica",
        aquacity: "AquaCity Poprad",
        paradise: "Slovenský Raj",
      },
    },
  },
  state: {
    free: {
      short: "V",
      title: "Voľný",
    },
    reservation: {
      short: "R",
      title: "Rezervovaný",
    },
    sold: {
      short: "PR",
      title: "Predaný",
    },
  },
  contact: {
    form_title: "V prípade záujmu nás{breakLine}neváhajte kontaktovať",
    subjectSuffix: "Detail bytu",
    labelEmail: "E-mail",
    labelPhone: "Telefónne číslo",
    labelAddress: "Adresa",
    labelFollow: "Sledujte nás",
    mapTitle: "Kde nás nájdete",
    mapButton: "Preskúmať lokalitu",
    mapDescription:
      "Bell\xa0residence sa nachádza na Suchoňovej ulici v mestskej časti Poprad-Juh{breakLine}a poskytuje dokonalé prepojenie mesta a prírody.",
  },
  default404: {
    title: "Stránka nebola nájdená",
    description:
      "Ospravedlňujeme sa, ale stránka, ktorú hľadáte, neexistuje.{breakLine}Skúste to prosím {link}.",
    link: "odznova",
  },
  finance: {
    title: "Financovanie",
    description:
      "Kúpu bytu v Bell\xa0Residence zvládnete v troch krokoch.{breakLine}Väčšinu ceny platíte až po kolaudácii. S hypotékou vám pomôže náš poradca.",
    contact_title:
      "Ak máte akékoľvek otázky o financovaní, náš finančný poradca vám rád pomôže.",
    step_1: {
      title: "Rezervačná zmluva",
      text: "Podpis Rezervačnej zmluvy + vyplatenie rezervačnej zálohy. Váš byt v Bell\xa0Residence vám rezervujeme za poplatok vo výške 3.000\xa0EUR s DPH. ",
    },
    step_2: {
      title: "Zmluva o budúcej zmluve",
      text: `Podpis Zmluvy o budúcej zmluve + úhrada ${depositPercent}% z ceny nehnuteľnosti z ktorej sa odráta rezervačná záloha 3.000 EUR, do\xa010 kalendárnych dní od podpisu rezervačnej zmluvy.`,
    },
    step_3: {
      title: "Kúpna zmluva",
      text: `Zvyšných ${restPercent}% z ceny nehnuteľnosti uhradíte po dokončení a kolaudácii bytového domu, pred odovzdaním nehnuteľnosti.`,
    },
    price_guarantee: {
      title: "*{breakLine}Garantovaná cena",
      text: "Po podpise Rezervačnej zmluvy a uhradení rezervačného poplatku vám garantujeme dohodnutú cenu bez uplatňovania si inflačnej doložky.",
    },
    loans: {
      title: "Hypotekárne financovanie je zabezpečené v týchto bankách:",
      csob: "ČSOB",
      unicredit: "UniCredit Bank",
      slsp: "SLSP",
    },
  },
  partners: {
    title: "Partneri projektu",
    description:
      "Pri budovaní Bell\xa0Residence spolupracujeme so spoľahlivými partnermi, ktorí zdieľajú náš dôraz na kvalitu, profesionalitu a komfort budúcich obyvateľov.",
    aboutTeaser: {
      title: "Partneri projektu",
      description:
        "Bell\xa0Residence vzniká v spolupráci so spoľahlivými partnermi, ktorí zabezpečujú nadštandardnú kvalitu a komfort vášho budúceho domova.",
      cta: "Zobraziť partnerov",
    },
    cta: {
      visitWebsite: "Navštívte webovú stránku",
    },
    items: {
      omega: {
        name: "Kúpeľňa Omega Hlohovec",
        role: "Kúpeľne · Toalety · Podlahy · Dvere",
        pills: [
          "25+ rokov skúseností",
          "500+ realizácií",
          "Návrh až po realizáciu",
        ],
        ctaLabel: "Konzultácia",
        blocks: [
          {
            text: "Spojenie moderných technológií a dizajnu na mieru vo vzorovom byte Bell\xa0Residence vytvára domov, kde sa budete cítiť výnimočne a doma. Vzorový byt je vizuálnou predprípravou pre váš budúci domov, aby ste videli ako funkčný, štýlový a pripravený na život môže byť aj pre vás.",
          },
          {
            text: "Kúpeľňu, toaletu, podlahy a interiérové dvere vo vzorovom byte zrealizovalo štúdio Kúpeľňa Omega Hlohovec. Toto štúdio sa stalo partnermi projektu a ponúka našim klientom nadštandardný servis od návrhu, cez dodanie materiálu až po kompletnú realizáciu kúpeľní, toaliet, podláh a interiérových dverí.",
          },
          {
            text: "Kúpeľňa Omega Hlohovec je rodinné, kúpeľňové a interiérové štúdio, ktoré viac ako 25 rokov tvorí nadčasové kúpeľne. Od návrhu až po realizáciu, spoľahlivo, esteticky a načas. Spájajú moderný dizajn, funkčnosť a precíznosť tak, aby vznikol priestor, kde sa budete cítiť výnimočne doma.",
          },
          {
            text: "Navštívte vzorový byt v Bell\xa0Residence alebo nás kontaktujte pre konzultáciu a cenovú ponuku.",
            link: "/kontakt",
            linkLabel: "Kontaktujte nás!",
          },
        ],
      },
      st: {
        name: "ST interiér s.r.o.",
        role: "Interiérový nábytok na mieru",
        pills: [
          "15+ rokov skúseností",
          "Vizualizácia v cene",
          "Realizácia na kľúč",
        ],
        ctaLabel: "Konzultácia",
        blocks: [
          {
            text: "Realizácia kompletného interiéru na mieru je od spoľahlivého partnera projektu, spoločnosti ST\xa0interiér s.r.o.",
          },
          {
            text: "ST\xa0interiér s.r.o. sa venuje výrobe interiérového nábytku na mieru a kompletnej realizácii interiérov viac ako 15 rokov. Posledné 3 roky pôsobia pod vlastnou značkou. Prioritou spoločnosti je kvalitná práca a spokojnosť zákazníka.",
          },
          {
            text: "Nábytok na mieru umožňuje dokonale využiť priestor podľa vašich predstáv, štýlu a potrieb. Vlastný nábytok vytvára unikátny charakter vášho domova a autentické prostredie.",
          },
          {
            text: "Pozrite si vzorový byt v Bell\xa0Residence alebo nás kontaktujte pre konzultáciu a cenovú ponuku.",
            link: "/kontakt",
            linkLabel: "Kontaktujte nás!",
          },
        ],
      },
      phillip: {
        name: "SMART riešenia Phillip",
        role: "Smart aplikácia pre obyvateľov",
        pills: ["Správa prístupov", "Parkovanie cez app", "Notifikácie z domu"],
        ctaLabel: "Otvoriť Phillip",
        blocks: [
          {
            text: "Súčasťou projektu Bell\xa0Residence je inteligentný systém Phillip s vlastnou mobilnou aplikáciou, ktorý prepája technológie budovy a služby pre obyvateľov do jedného prehľadného prostredia.",
          },
          {
            text: "Prostredníctvom aplikácie môžu obyvatelia komunikovať s návštevou cez videovrátnik, spravovať prístupy do budovy či parkovania a mať prehľad o dôležitých udalostiach v dome.",
          },
          {
            text: "Smart riešenie prináša vyšší komfort, bezpečnosť a jednoduchú správu bývania priamo z mobilného telefónu.",
          },
          {
            text: "Viac informácií o systéme Phillip nájdete na",
            link: "https://phillip.city/bellresidence/",
            linkLabel: "phillip.city/bellresidence",
          },
        ],
      },
    },
  },
  team: {
    // People data lives in src/utils/contacts.ts (version-dependent)
    title: "Náš tím",
  },
  faq: {
    title: "Časté otázky",
    items: [
      {
        question: "Kde presne Bell Residence stojí?",
        answer:
          "Na Suchoňovej ulici v mestskej časti Poprad-Juh. Do centra mesta sú to približne 3 kilometre. Zastávka MHD je 350 metrov od domu.",
      },
      {
        question: "Budem mať kde parkovať?",
        answer:
          "Áno. Projekt má 98 parkovacích miest vrátane podzemnej garáže. Keďže domy nebudú mať polyfunkciu, nehrozí žiadne obsadzovanie neznámymi ľuďmi.",
      },
      {
        question: "Má byt pivnicu?",
        answer:
          "Áno, každý byt má svoju kobku na uskladnenie vecí. Kupujúci si ju musí zakúpiť k bytu. Detaily k bytom alebo ku kobkám vám samozrejme radi pošleme.",
      },
      {
        question: "Aké budú mesačné náklady?",
        answer:
          "Dom má energetickú triedu A. Teplú vodu pomáha ohrievať fotovoltika na streche. Prevádzka je preto úsporná. Odhad pre konkrétny byt vám pripravíme na vyžiadanie.",
      },
      {
        question: "Je blízko škola a škôlka?",
        answer:
          "Áno. Základná aj materská škola sú približne 500 metrov od rezidencie.",
      },
      {
        question: "Kde nakúpim?",
        answer:
          "Potraviny sú 300 metrov od domu. OC MAX Poprad je vzdialený 1 km a Kaufland a Lidl sú približne 1,4 kilometra od rezidencie.",
      },
      {
        question: "Ako ďaleko sú Tatry?",
        answer:
          "Do Starého Smokovca je to 14 kilometrov, autom približne 20 minút. Do Tatranskej Lomnice 18 kilometrov.",
      },
      {
        question: "Ako prebieha kúpa bytu?",
        answer: `V troch krokoch. Najprv rezervačná zmluva a záloha 3 000 eur. Potom zmluva o budúcej zmluve a úhrada ${depositPercent} % z ceny. Zvyšných ${restPercent} % zaplatíte až po kolaudácii.`,
      },
      {
        question: "Kedy bude dom hotový?",
        answer:
          "Predpokladaný termín kolaudácie celého projektu Bell Residence je naplánovaný na koniec roka 2026, resp. začiatok roka 2027.",
      },
    ],
  },
};

export const breakLine = <br />;

export const toPlainText = (translation: string) =>
  translation
    .replace(/\{[^}]+\}/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const insertElement = (
  translation: string,
  placeholders: Record<string, React.ReactNode>,
) =>
  translation
    .split(/\{(\w+)\}/g)
    .map((part, i) =>
      i % 2 === 1 &&
      Object.prototype.hasOwnProperty.call(placeholders, part) ? (
        <React.Fragment key={i}>{placeholders[part]}</React.Fragment>
      ) : (
        part
      ),
    );
